import { TypedUseSelectorHook, useDispatch, useSelector } from "react-redux";

import adminReducer from "./slices/adminSlice";
import appReducer from "./slices/appSlice";
import { configureStore } from "@reduxjs/toolkit";
import lessonReduser from "./slices/lessonSlice";
import userReducer from "./slices/userSlice";
import workspaceReducer from "./slices/workspaceSlice";

export const store = configureStore({
  reducer: {
    app: appReducer,
    user: userReducer,
    lesson: lessonReduser,
    admin: adminReducer,
    workspace: workspaceReducer,
  },
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

// Use throughout your app instead of plain `useDispatch` and `useSelector`
export const useAppDispatch: () => AppDispatch = useDispatch;
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
